import ReactDOM from 'react-dom/client'

import reportWebVitals from './reportWebVitals'
import App from './app/pages/app'

import './styles/globals.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)

// If you want to start measuring performance in your app, pass a functions dev2
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
